<ng-container>
  <div class="b">
    <nav aria-label="breadcrumb" >
      <ol class="breadcrumb">
        <li class= "breadcrumb-item active"  *ngFor="let item of breadCrumb" >
          <a href='#' (click)="loadHistoryFromBreadCrumb(item);$event.preventDefault()"><span>{{item.title}}</span></a>
        </li>
      </ol>
    </nav>
  </div>
</ng-container>


